"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ElementCoreContext {
    constructor() {
        this.alpha = 1;
        this.px = 0;
        this.py = 0;
        this.ta = 1;
        this.tb = 0;
        this.tc = 0;
        this.td = 1;
    }
    isIdentity() {
        return (this.alpha === 1 &&
            this.px === 0 &&
            this.py === 0 &&
            this.ta === 1 &&
            this.tb === 0 &&
            this.tc === 0 &&
            this.td === 1);
    }
    isSquare() {
        return this.tb === 0 && this.tc === 0;
    }
}
exports.ElementCoreContext = ElementCoreContext;
ElementCoreContext.IDENTITY = new ElementCoreContext();
//# sourceMappingURL=ElementCoreContext.js.map